module.exports = __webpack_public_path__ + "static/media/vl.a2fe0c81.jpg";